// Template library for custom chart/table blocks

export const TEMPLATE_LIBRARY = [
  // Charts
  {
    id: 'perf_line_chart',
    label: 'Performance Line Chart',
    description: 'Portfolio vs benchmark performance over time',
    category: 'chart',
    dataKey: 'time_series',
  },
  {
    id: 'allocation_donut',
    label: 'Allocation Donut',
    description: 'Current portfolio asset allocation breakdown',
    category: 'chart',
    dataKey: 'allocation',
  },
  {
    id: 'allocation_vs_saa_bar',
    label: 'Allocation vs SAA',
    description: 'Actual allocation compared to strategic asset allocation',
    category: 'chart',
    dataKey: 'allocation_vs_saa',
  },
  {
    id: 'active_tilts_bar',
    label: 'Active Tilts',
    description: 'Active portfolio tilts relative to benchmark',
    category: 'chart',
    dataKey: 'active_tilts',
  },
  {
    id: 'historical_allocation_area',
    label: 'Historical Allocation',
    description: 'Historical portfolio asset allocation over time',
    category: 'chart',
    dataKey: 'historical_allocation',
  },
  {
    id: 'credit_exposure_bar',
    label: 'Credit Exposure',
    description: 'Portfolio credit grade exposure breakdown',
    category: 'chart',
    dataKey: 'credit_exposure',
  },
  // Tables
  {
    id: 'perf_risk_table',
    label: 'Performance & Risk',
    description: 'Performance and risk metrics table',
    category: 'table',
    dataKey: 'performance',
  },
  {
    id: 'perf_risk_monthly_table',
    label: 'Performance & Risk (Monthly)',
    description: 'Performance and risk metrics table including 1-month return',
    category: 'table',
    dataKey: 'performance',
  },
  {
    id: 'fy_returns_table',
    label: 'FY Returns',
    description: 'Financial year returns comparison',
    category: 'table',
    dataKey: 'fy_returns',
  },
  {
    id: 'holdings_table',
    label: 'Top Holdings',
    description: 'Top 5 active holdings and portfolio characteristics',
    category: 'table',
    dataKey: 'top_5_holdings',
  },
  // FactSheet-style charts
  {
    id: 'fs_allocation_bar',
    label: 'Allocation Bar Chart',
    description: 'Vertical bar chart of portfolio asset allocation',
    category: 'chart',
    dataKey: 'allocation',
  },
  {
    id: 'fs_credit_pie',
    label: 'Credit Exposure Pie',
    description: 'Pie chart with legend for credit grade exposure',
    category: 'chart',
    dataKey: 'credit_exposure',
  },
  {
    id: 'fs_performance_line',
    label: 'Performance Since Inception',
    description: 'Line chart with extra series support (Cash, CPI targets)',
    category: 'chart',
    dataKey: 'time_series',
  },
  // FactSheet-style tables
  {
    id: 'fs_holdings_by_class',
    label: 'Holdings by Asset Class',
    description: 'Full holdings grouped by asset class with rowspans',
    category: 'table',
    dataKey: 'holdings',
  },
  {
    id: 'fs_top10_holdings',
    label: 'Top 10 Stock Holdings',
    description: 'Top 10 look-through stock holdings with country',
    category: 'table',
    dataKey: 'top_10_lookthrough',
  },
  {
    id: 'contribution_table',
    label: 'Contribution to Return',
    description: 'Top 5 and bottom 5 holdings by contribution to return',
    category: 'table',
    dataKey: 'contribution_analysis',
  },
  {
    id: 'market_review_table',
    label: 'Market Review',
    description: '3M/6M/1Y % change across key market indices, grouped by asset class',
    category: 'table',
    dataKey: 'market_returns',
  },
  {
    id: 'market_review_monthly_table',
    label: 'Market Review (Monthly)',
    description: '1M/3M/6M/1Y % change across key market indices, grouped by asset class',
    category: 'table',
    dataKey: 'market_returns_monthly',
  },
  {
    id: 'tactical_tilts_table',
    label: 'Tactical Tilts',
    description: 'Overweight / Underweight / Neutral positioning per asset class based on SAA tilts',
    category: 'table',
    dataKey: 'active_tilts',
  },
  // New charts
  {
    id: 'waterfall_chart',
    label: 'Contribution Waterfall',
    description: 'Waterfall chart showing holding contributions and detractors',
    category: 'chart',
    dataKey: 'contribution_analysis',
  },
  {
    id: 'sector_exposure_chart',
    label: 'Sector Exposure',
    description: 'Grouped bar chart comparing actual allocation vs SAA by sector',
    category: 'chart',
    dataKey: 'allocation_vs_saa',
  },
  {
    id: 'risk_return_scatter',
    label: 'Risk/Return Scatter',
    description: 'Scatter plot of portfolio vs peer risk and return',
    category: 'chart',
    dataKey: 'performance',
  },
  {
    id: 'drawdown_chart',
    label: 'Drawdown Chart',
    description: 'Drawdown from peak over time based on portfolio time series',
    category: 'chart',
    dataKey: 'time_series',
  },
  {
    id: 'growth_defensive_chart',
    label: 'Growth vs Defensive',
    description: 'Horizontal stacked bar showing growth/defensive split',
    category: 'chart',
    dataKey: 'allocation',
  },
  // New tables
  {
    id: 'asset_class_summary_table',
    label: 'Asset Class Summary',
    description: 'Asset class weights vs SAA with active tilts',
    category: 'table',
    dataKey: 'allocation_vs_saa',
  },
  {
    id: 'risk_metrics_table',
    label: 'Risk Metrics',
    description: 'Portfolio vs peer risk metrics including volatility, Sharpe, and drawdown',
    category: 'table',
    dataKey: 'volatility_data',
  },
  {
    id: 'fund_comparison_table',
    label: 'Fund Comparison',
    description: 'Holdings with asset class, weight, and growth/defensive classification',
    category: 'table',
    dataKey: 'holdings',
  },
  {
    id: 'quarterly_attribution_table',
    label: 'Quarterly Attribution',
    description: 'Asset class contribution ranking for the quarter',
    category: 'table',
    dataKey: 'contribution_analysis',
  },
  {
    id: 'portfolio_characteristics_table',
    label: 'Portfolio Characteristics',
    description: 'Key-value summary of portfolio characteristics and risk metrics',
    category: 'table',
    dataKey: 'performance',
  },
  // Lookthrough blocks
  {
    id: 'contribution_table_3',
    label: 'Top/Bottom 3 Contributors',
    description: 'Top 3 and bottom 3 portfolio contributors for 3M and 12M',
    category: 'table',
    dataKey: 'contribution_analysis',
  },
  {
    id: 'global_equity_top10',
    label: 'Top 10 International Equity Exposure',
    description: 'Top 10 international stock holdings excluding Australia',
    category: 'table',
    dataKey: 'global_top_10_lookthrough',
  },
  {
    id: 'domestic_equity_top10',
    label: 'Top 10 Domestic Equity Exposure',
    description: 'Top 10 Australian stock holdings',
    category: 'table',
    dataKey: 'domestic_top_10_lookthrough',
  },
  {
    id: 'regional_lookthrough_chart',
    label: 'Regional Exposure vs Benchmark',
    description: 'International equity region exposure compared to benchmark',
    category: 'chart',
    dataKey: 'regional_lookthrough',
  },
  {
    id: 'sector_lookthrough_chart',
    label: 'AU Sector Exposure vs Benchmark',
    description: 'Australian equities sector exposure compared to ASX300',
    category: 'chart',
    dataKey: 'sector_lookthrough',
  },
  {
    id: 'global_sector_lookthrough_chart',
    label: 'International Sector Exposure vs Benchmark',
    description: 'International equities sector exposure compared to MSCI ACWI',
    category: 'chart',
    dataKey: 'global_sector_lookthrough',
  },
];

export function generateBlockId(prefix) {
  const uuid = crypto.randomUUID().replace(/-/g, '').slice(0, 8);
  return `${prefix}_${uuid}`;
}
